"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MapRegion } from "./mapData";

type Props = {
  region: MapRegion;
};

export default function MapHotspot({ region }: Props) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="absolute"
      style={{
        top: region.bounds.top,
        left: region.bounds.left,
        width: region.bounds.width,
        height: region.bounds.height,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* HIT AREA */}
      <div
        className="absolute inset-0 cursor-pointer"
        style={{
          clipPath: region.polygon,
        }}
      />

      {/* OVERLAY */}
      <AnimatePresence>
        {hovered && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="absolute inset-0 bg-[#7A692A]/70 "
            style={{ clipPath: region.polygon }}
          />
        )}
      </AnimatePresence>

      {/* TOOLTIP */}
      <AnimatePresence>
        {hovered && (
          <motion.div
            initial={{ opacity: 0, y: 8, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.98 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            className="
        absolute z-20
        left-1/2 bottom-full mb-4
        -translate-x-1/2
        w-64 sm:w-72 md:w-80 lg:w-96
        rounded-xl bg-white shadow-lg
        p-3 sm:p-4 md:p-5
        pointer-events-none
      "
          >
            <h4
              className="
        font-semibold text-primary mb-1
        text-xs sm:text-sm md:text-base
      "
            >
              {region.label}
            </h4>

            <p
              className="
        text-gray leading-relaxed
        text-[11px] sm:text-xs md:text-sm
      "
            >
              {region.description}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
